import React, { useState, useEffect } from 'react';
import { toHHMMSS } from '../../../utility/common';

export const TimerButton = (props: { duration: number; text: string; onclick: () => any }) => {
  const [seconds, setSeconds] = useState(props.duration);
  const [isActive, setIsActive] = useState(false);

  function toggle() {
    setIsActive(!isActive);
  }

  function reset() {
    setSeconds(props.duration);
    setIsActive(true);
  }

  useEffect(() => {
    setIsActive(true);
  }, []);

  useEffect(() => {
    let interval: any = null;
    if (isActive) {
      interval = setInterval(() => {
        if (seconds > 0) {
          setSeconds((seconds) => seconds - 1);
        } else {
          setIsActive(false);
          setSeconds(props.duration);
        }
      }, 1000);
    }
    return () => clearInterval(interval);
  }, [isActive, seconds]);

  return (
    <button
      className="bg-transparent w-full p-3 rounded-lg font-normal text-theLighterDark border border-theLighterDark"
      onClick={() => {
        reset();
      }}
    >
      {!isActive ? props.text : toHHMMSS(seconds.toString())}
    </button>
  );
};
